import { faEye, faPen, faTrash } from "@fortawesome/free-solid-svg-icons"
import { Pagination } from "@wfp/ui"
import Button from "components/Shared/Button/Button"
import DataTable from "components/Shared/DataTable/DataTable"
import { formatDate } from "utils/helpers"
import { useAppDispatch, useAppSelector } from "hooks/hooksStore"
import { BaseXlsForm as BaseXlsFormType, SearchResponse } from "interfaces/dataInterfaces"
import { Column, ColumnShape } from "react-base-table"
import PermissionWrapper from "components/Shared/Common/PermissionWrapper"
import { getPageNumber, setPageNumber, setTop, getTop } from "./baseXlsFormSlice"

interface TableProps {
  data: SearchResponse<BaseXlsFormType> | undefined
  isFetching?: boolean
  onEditClick?: (data: BaseXlsFormType) => void
  onDeleteClick?: (data: BaseXlsFormType) => void
  onDetailsClick?: (data: BaseXlsFormType) => void
  permissionsParams: any
}

export default function Table({
  data,
  isFetching,
  onDeleteClick,
  onDetailsClick,
  permissionsParams,
  onEditClick,
}: TableProps) {
  const dispatch = useAppDispatch()
  const pageNumber = useAppSelector(getPageNumber)
  const pageSize = useAppSelector(getTop)

  const columns: Array<ColumnShape<BaseXlsFormType>> = [
    {
      key: "xlsFormId",
      dataKey: "xlsFormId",
      title: "ID",
      width: 80,
    },

    {
      key: "xlsFormName",
      dataKey: "xlsFormName",
      title: "XLSForm Name",
      width: 600,
      flexGrow: 1,
      resizable: true,
    },

    {
      key: "xlsFormCreateDate",
      // dataKey: "xlsFormCreateDate",
      title: "Created Date",
      width: 200,
      cellRenderer: ({ rowData }) => formatDate(rowData.xlsFormCreateDate),
    },
    {
      key: "userName",
      dataKey: "userName",
      title: "Created By",
      width: 300,
      minWidth: 200,
      resizable: true,
    },
    {
      key: "action",
      title: "Action",
      width: 350,
      align: Column.Alignment.CENTER,
      cellRenderer: ({ rowData }) => (
        <>
          <PermissionWrapper {...permissionsParams} feature="details">
            <Button
              action={() => onDetailsClick?.(rowData)}
              label="Details"
              className="btn-full blue action-btn"
              icon={faEye}
            />
          </PermissionWrapper>

          {onEditClick && (
            <PermissionWrapper {...permissionsParams} feature="edit">
              <Button
                action={() => onEditClick(rowData)}
                label="Edit"
                className="btn-full green action-btn"
                style={{ marginLeft: "10px" }}
                icon={faPen}
              />
            </PermissionWrapper>
          )}

          <PermissionWrapper {...permissionsParams} feature="delete">
            <Button
              action={() => onDeleteClick?.(rowData)}
              label="Delete"
              className="btn-full danger action-btn"
              style={{ marginLeft: "10px" }}
              icon={faTrash}
            />
          </PermissionWrapper>
        </>
      ),
    },
  ]

  if (!data) return null

  return (
    <>
      <DataTable {...{ columns, isFetching }} data={data.items} rowKey="xlsFormId" />
      <Pagination
        totalItems={data.count}
        pageSize={pageSize}
        pageSizes={[10, 20, 30]}
        page={pageNumber}
        onChange={(event): void => {
          dispatch(setPageNumber((event as any).page))
          dispatch(setTop((event as any).pageSize))
        }}
      />
    </>
  )
}
